module.exports = __webpack_public_path__ + "img/jiebang.af6b6a3e.png";